/**
 * Sens d'un geste au doigt ou au stylet, tranché une fois pour toutes dès qu'il
 * a assez bougé. Sert à la ligne des notes, qui défile à l'horizontale alors
 * que ses notes se glissent vers le plan (en dessous) : un geste horizontal
 * fait défiler, un geste vertical attrape la note.
 *
 * Le même calcul est fait des deux côtés (le bouton qui se glisse et la ligne
 * qui défile) : ils prennent donc toujours la même décision.
 */
export type GestureDirection = "pending" | "horizontal" | "vertical";

/** Distance (px écran) avant de trancher : en dessous, c'est encore un appui. */
export const GESTURE_LOCK_PX = 8;

export function classifyGesture(
  dx: number,
  dy: number,
  threshold: number = GESTURE_LOCK_PX,
): GestureDirection {
  const ax = Math.abs(dx);
  const ay = Math.abs(dy);
  if (Math.max(ax, ay) < threshold) return "pending";
  // À égalité, le défilement l'emporte : une note lâchée par erreur sur le
  // plan coûte plus cher qu'un défilement non voulu.
  return ax >= ay ? "horizontal" : "vertical";
}
